import React from 'react';
import { Box, Button, Typography, Paper } from '@mui/material';

const QuizNavigation = ({ questions, userAnswers, currentQuestionIndex, onQuestionSelect }) => {
    
    // Determines the color of the button based on the question's state
    const getStatusColor = (index) => {
        if (index === currentQuestionIndex) {
            return 'primary'; // The currently selected question
        }
        if (userAnswers[index] !== null) {
            return 'success'; // An answered question
        }
        return 'inherit'; // An unanswered/unseen question
    };

    // Determines the variant of the button (filled or outlined)
    const getStatusVariant = (index) => {
        if (index === currentQuestionIndex) {
            return 'contained';
        }
        return 'outlined';
    };

    return (
        <Paper elevation={2} sx={{ p: 2, mt: 4 }}>
            <Typography variant="h6" gutterBottom align="center">
                Question Navigator
            </Typography>
            <Box sx={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: 1.5, // A little more space between buttons
                justifyContent: 'center' // Center the buttons within the box
            }}>
                {questions.map((_, index) => (
                    <Button
                        key={index}
                        variant={getStatusVariant(index)}
                        color={getStatusColor(index)}
                        onClick={() => onQuestionSelect(index)}
                        sx={{
                            minWidth: '45px', // Ensure buttons are nicely sized
                            height: '45px',
                            borderRadius: '50%', // Make them circular
                            fontSize: '1rem',
                        }}
                        aria-label={`Go to question ${index + 1}`}
                    >
                        {index + 1}
                    </Button>
                ))}
            </Box>
        </Paper>
    );
};

export default QuizNavigation;
